export default __webpack_public_path__ + "static/media/education.62147e5c.png";